import * as t from "io-ts";
import { DynamicFieldOutputV } from "@/types/dynamic-data";

export const ConditionValueV = t.type({
  text: t.string,
  value: t.string
});

export type ConditionValue = t.TypeOf<typeof ConditionValueV>;

export type VuetifyShapeForSelect =
  | ConditionValue
  | { header: string }
  | { divider: true };

const OperandsV = t.union([
  t.literal("is"),
  t.literal("is not"),
  t.literal("is one of"),
  t.literal("is all of"),
  t.literal("is none of"),
  t.literal("is before"),
  t.literal("is after"),
  t.literal("is greater than"),
  t.literal("is less than"),
  t.literal("contains"),
  t.literal("does not contain"),
  t.literal("is empty"),
  t.literal("is not empty"),
  t.string
]);

export type ConditionOperands = t.TypeOf<typeof OperandsV>;

export const RuleV = t.partial({
  ruleSlug: t.string,
  ruleDynamic: t.union([t.string, t.undefined]),
  ruleDynamicMeta: t.union([DynamicFieldOutputV, t.undefined]),
  operand: OperandsV,
  value: t.union([
    t.string,
    t.number,
    t.array(t.string),
    t.array(ConditionValueV)
  ]),
  valueDynamicMeta: t.union([DynamicFieldOutputV, t.undefined])
});

export type Rule = t.TypeOf<typeof RuleV>;

export const RuleGroupV = t.array(RuleV);

export type RuleGroup = t.TypeOf<typeof RuleGroupV>;

export const ConditionItemGroupV = t.intersection([
  t.type({
    label: t.string,
    items: t.array(ConditionValueV)
  }),
  t.partial({
    availableForType: t.union([t.literal(false), t.array(t.string)])
  })
]);

export type ConditionItemGroup = t.TypeOf<typeof ConditionItemGroupV>;

export const ConditionV = t.exact(
  t.type({
    slug: t.string,
    label: t.string,
    category: t.string,
    operands: t.array(OperandsV),
    values: t.union([t.array(ConditionItemGroupV), t.literal(false)]),
    valueInputType: t.union([
      t.undefined,
      t.literal("dropdown"),
      t.literal("datepicker"),
      t.literal("number"),
      t.literal("timepicker")
    ]),
    availableForType: t.array(t.string),
    supports: t.array(
      t.union([
        t.literal("element_display"),
        t.literal("templating"),
        t.literal("query_builder")
      ])
    ),
    proOnly: t.union([t.undefined, t.boolean])
  })
);

export const ConditionsV = t.array(ConditionV);

export type Condition = t.TypeOf<typeof ConditionV>;

export const TriggerOptionsV = t.partial({
  delay: t.number,
  percent: t.number,
  selector: t.string,
  scrollType: t.string,
  clickType: t.string,
  limit: t.number
});

export const TriggerV = t.partial({
  slug: t.string,
  options: TriggerOptionsV
});

export const TriggersV = t.array(TriggerV);

export type Trigger = t.TypeOf<typeof TriggerV>;
